import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import DateTimeLabelViewModel from '@/ViewModels/Controls/DateTimeLabelViewModel';

export default class PrincipalHistorizationPreviewItemViewModel extends ControlViewModel {

    /**
     * Das Bild für den Kommentar
     */
    public image: ImageViewModel;

    /**
     * Der Name des Mandanten
     */
    public label: LabelViewModel;

    /**
     * Der Zeitpunkt der Historisierung des Mandanten
     */
    public datetimelabel: DateTimeLabelViewModel;

    /**
     * Das ViewModel für den PrincipalHistorizationPreviewItem
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.image = this.paramOrDefault(params.image, null);
        this.label = this.paramOrDefault(params.label, null);
        this.datetimelabel = this.paramOrDefault(params.datetimelabel, null);
    }
}

ComponentManager.setViewModel('PrincipalHistorizationPreviewItemViewModel', PrincipalHistorizationPreviewItemViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');